import { render, staticRenderFns } from "./registerComponent.vue?vue&type=template&id=5884dacc&scoped=true"
import script from "./registerComponent.vue?vue&type=script&lang=js"
export * from "./registerComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5884dacc",
  null
  
)

export default component.exports